import React from "react";
import { Helmet } from "react-helmet";

import Page from "../../components/layout/Page";

//@ts-ignore
import showroomBg from "../../assets/images/showroom-hero.jpg";
//@ts-ignore
import cat1 from "../../assets/images/programare.jpg";
//@ts-ignore
import img3 from "../../assets/images/pages/3.jpg";

export default function Programare() {
  return (
    <Page>
      {
        //@ts-ignore
        <Helmet>
          <title>
            Programare & Integrare Sisteme Smart Home | Asempera Cluj
          </title>
          <meta
            name="description"
            content={`Partener Oficial Loxone în Cluj-Napoca. Asigurăm programare și integrare profesională a sistemelor smart home (lumini, climatizare, securitate, audio) pentru un confort desăvârșit.`}
          />
        </Helmet>
      }
      <div
        className="page-title with-background"
        style={{ backgroundImage: `url(${cat1})` }}
      >
        <div className="shade"></div>
        <h1>Programare & Integrare</h1>
      </div>
      <div className="an-section">
        <div className="an-content">
          <p>
            O casă inteligentă nu este doar o colecție de dispozitive smart.
            Este un <strong>ecosistem</strong> în care tehnologia dispare,
            lăsând în urmă doar confortul. Aici intervine magia programării:
            transformăm componentele individuale într-o{" "}
            <strong>experiență</strong> unitară și <strong>intuitivă</strong>.
          </p>
        </div>
      </div>
      <div className="an-section bg-1">
        <div className="an-content flex align-center">
          <div className="an-col w-6">
            <p className="mb-0">
              Procesul de programare este locul unde viziunea ta devine acțiune.
              Luăm scenariile pe care le-am stabilit împreună și, folosind{" "}
              <strong>expertiza noastră avansată în platforma Loxone</strong>,
              le traducem în comenzi inteligente și automate pentru casa ta.
              <br></br>
              <br></br>
              <strong>Ne ocupăm de toată configurația</strong> din spate, pentru
              ca tu să te bucuri de un rezultat simplu: o casă care răspunde
              intuitiv nevoilor tale, fără efort. Detaliile fine ale
              personalizării le vom gândi împreună, pentru a ne asigura că
              fiecare element ți se potrivește perfect.
            </p>
          </div>
          <div className="an-col w-6">
            <img src={img3} className="max-400 center"></img>
          </div>
        </div>
      </div>
      {/* <div id="showroom">
        <div
          className="bg-section"
          style={{ backgroundImage: `url(${showroomBg})` }}
        ></div>
        <div className="shade"></div>
        <div className="an-section">
          <div className="an-content flex center">
            <div className="an-col w-8 text">
              <h1>E timpul să faci primul pas către casa viitorului.</h1>
              <p>
                Nu trebuie să fii expert în tehnologie, de asta ne ocupăm noi.
                Suntem aici să îți răspundem la întrebări și să îți arătăm ce
                este posibil.
              </p>
              <p>
                Hai să discutăm proiectul tău, virtual sau la sediul nostru din
                Cluj-Napoca și să conturăm împreună viitorul casei tale.
              </p>
              <p className="small-notice">
                Statutul de Partener Oficial Loxone ne certifică expertiza și ne
                obligă la excelență. Alegând Asempera, alegeți o echipă de
                încredere, instruită și validată direct de producător, gata să
                implementeze cele mai avansate soluții de automatizare Loxone.
              </p>
              <a className="special-button" href="/#contact">
                Hai să discutăm proiectul tău.
              </a>
            </div>
            <div className="an-col w-4 blank"></div>
          </div>
        </div>
      </div> */}
    </Page>
  );
}
